<template>
  <el-dialog :body-padding="false" :width="width" :height="height" :append-to-body="true" :stopPropagation="false"
             :visible="$attrs.visible" :title="title" :close-on-press-escape="false"  @closed="handleClosed" @opened="handleOpened">
    <x-page-container class="common-page-container common-dialog-content">
      <template v-slot:header>
        <x-button-group :button-config="$attrs.buttonConfig || $attrs['button-config']"></x-button-group>
      </template>
      <template v-slot:main>
<!--        <el-scrollbar ref="scrollbar" class="main-scroll-bar">-->
        <div class="main-scroll-bar">
          <x-condition ref="xCondition" :condition-config="conditionConfig"></x-condition>
        </div>
<!--        </el-scrollbar>-->
      </template>
      <template v-slot:footer>
        <slot name="footer"></slot>
      </template>
    </x-page-container>
  </el-dialog>
</template>

<script>
import {FIELD_TYPE_FILE} from '@/util/x-condition-constant';

export default {
  name: 'DetailDialog',
  props: {
    width: {
      type: String,
      default: '80vw'
    },
    height: {
      type: String,
      default: '80vh'
    },
    title: {
      type: String,
      default: '详情'
    },
    conditionConfig: Object
  },
  methods: {
    handleOpened(e) {
      this.$emit('opened', e);
    },
    handleClosed() {
      this.$emit('update:visible', false);
      // 清空上传文件的fileList
      for (const item of this.conditionConfig.list) {
        if (item.type === FIELD_TYPE_FILE) {
          item.fileList = [];
        }
      }
    },
    validate() {
      return this.$refs.xCondition.validate();
    }
  }
}
</script>

<style lang="scss">
</style>